document.addEventListener('DOMContentLoaded', function () {

  const header = document.getElementById('SiteHeader');
  const toggleBtn = header?.querySelector('#site-nav-toggle-btn');
  const navSection = header?.querySelector('.header-item--mobile-site-nav-tabs .mobile-site-navigation-section');
  const navTabs = header?.querySelector('.header-item--mobile-site-nav-tabs');
  const iconsWrapper = header?.querySelector('.header-item--icons');
  const vinCenter = header?.querySelector('.vin-absolute-center');

  if (!header || !toggleBtn || !navSection || !navTabs || !iconsWrapper || !vinCenter) {
    console.warn('Missing element(s) in mobile nav logic');
    return;
  }

  toggleBtn.addEventListener('click', function () {
    const isOpen = getComputedStyle(navSection).display !== 'none';

    if (isOpen) {
      // Hide it
      navSection.style.display = 'none';
      navTabs.style.marginTop = '0px';
      navTabs.style.marginBottom = '0px';
    } else {
      // Show it
      navSection.style.display = 'block';
      navSection.offsetHeight; // force reflow

      const heightOfWrapper = iconsWrapper.offsetHeight;
      navTabs.style.marginTop = '20px';
      navTabs.style.marginBottom = '10px';
      vinCenter.style.top = (heightOfWrapper - navTabs.offsetHeight) + 'px';
    }
  });
  const siteTabsContainer = document.querySelector('.mobile-site-navigation-section div .site-tabs-container');
  const siteTabs = siteTabsContainer.querySelectorAll('.site-tab');

  siteTabs.forEach((tab) => {
    tab.addEventListener('click', function () {
      sessionStorage.setItem('currentStore', tab.innerText);
      // setActiveTab();
    });
  });
});
